import * as yup from 'yup';

import subscriptionEmailValidation from './subscribtionEmailValidation';

const schema = () =>
  yup.object().shape({
    email: subscriptionEmailValidation(),
  });

export default schema;
